// extracted by mini-css-extract-plugin
export default {"wrapper":"_w-z","button":"ax-z","alternate":"bx-z","disabled":"cx-z","paymentWarning":"dx-z","fadeIn":"ex-z"};